<template lang="pug">
  .text-xs-center.pa-3.primary--text
    v-progress-circular(indeterminate)
    h5.mt-2 Cargando Datos
</template>

<script>
export default {

}
</script>